import { configureStore } from "@reduxjs/toolkit"

import authReducer from "./slices/authSlice"
import userReducer from "./slices/userSlice"

import categoryReducer from "./slices/categorySlice"
import collectionReducer from "./slices/collectionSlice"

import productReducer from "./slices/productSlice"
import homeReducer from "./slices/homeSlice"
import searchReducer from "./slices/searchSlice"

import alertReducer from "./slices/alertSlice"
import loaderReducer from "./slices/loaderSlice"

import cartReducer from "./slices/cartSlice"
import orderReducer from "./slices/orderSlice"

const store = configureStore({
  
  reducer: {

    auth: authReducer,
    user: userReducer,

    category: categoryReducer,
    collection: collectionReducer,

    product: productReducer,

    home: homeReducer,
    search: searchReducer,

    alert: alertReducer,
    loader: loaderReducer,

    cart:cartReducer,
    order: orderReducer

  }

})


export default store